<template>
  <b-card no-body
    :title="name" >

    <div class="px-3 pt-2">
      <h5>{{ name || 'Untitled customer list' }}</h5>
    </div>

    <b-list-group>
      <b-list-group-item class="px-3 py-2" v-for="c in filters" :key="c.id">
        <i class="fa fa-arrow-up text-success" v-if="c.ascending"></i>
        <i class="fa fa-arrow-down text-danger" v-else></i>
        <span class="d-inline-block ml-1">
          {{ c.column }}
        </span>
      </b-list-group-item>
    </b-list-group>

    <b-card-footer class="px-3 py-1">
      <b-row align-v="center">
        <b-col :cols="6">
          <b-button @click="$emit('view')" size="sm" variant="primary">
            <i class="fa fa-eye mr-1"></i>
            view
          </b-button>
        </b-col>
        <b-col :cols="6" class="text-right">
          <b-button size="sm" variant="outline-success" @click="$emit('edit')">
            <i class="fa fa-pencil mr-1"></i>
            edit
          </b-button>
          <b-button size="sm" variant="outline-danger" @click="$emit('delete')">
            <i class="fa fa-trash-o mr-1"></i>
            delete
          </b-button>
        </b-col>
      </b-row>
    </b-card-footer>

  </b-card>
</template>

<script>
  export default {
    name: 'ListSummary',

    props: {
      id: String,
      name: String,
      filters: Array
    }
  };
</script>
